export function scrollToHash() {
  if (window.location.hash) {
    const el = document.querySelector(window.location.hash);
    if (el) {
      setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 0);
    }
  }
}
